"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("defs", {
      children: (0, _jsxRuntime.jsx)("path", {
        d: "M19.104 17.933a5.772 5.772 0 00-2.259-8.716 6.596 6.596 0 10-11.7 5.187l-1.146 1.138a.825.825 0 00-.173.898c.126.308.425.51.758.512h4.692a5.772 5.772 0 005.203 3.298h4.947a.825.825 0 00.759-.511.825.825 0 00-.174-.899l-.907-.907zM8.707 14.478c.001.276.023.552.066.825H6.571l.289-.28a.825.825 0 000-1.172 4.89 4.89 0 01-1.451-3.496 4.947 4.947 0 014.947-4.947 4.898 4.898 0 014.659 3.298h-.536a5.772 5.772 0 00-5.772 5.772zm8.69 4.123l.042.041h-2.96a4.123 4.123 0 112.919-1.204.825.825 0 00-.248.577c.001.22.09.432.248.586z",
        id: "prefix__a__duo"
      })
    }), (0, _jsxRuntime.jsxs)("g", {
      fill: "currentColor",
      fillRule: "evenodd",
      children: [(0, _jsxRuntime.jsx)("mask", {
        id: "prefix__b__duo",
        children: (0, _jsxRuntime.jsx)("use", {
          xlinkHref: "#prefix__a__duo"
        })
      }), (0, _jsxRuntime.jsx)("use", {
        fillRule: "nonzero",
        xlinkHref: "#prefix__a__duo"
      }), (0, _jsxRuntime.jsx)("path", {
        mask: "url(#prefix__b__duo)",
        d: "M0 0h24v24H0z"
      })]
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=ChatDuoOutlined.js.map